export default __webpack_public_path__ + "static/gh-390ed9c6e49d13770e60eb5f060bc25f.svg";